/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IAccountRecoveryState } from 'store/types';
import * as ActionTypes from './types';

const initialState: IAccountRecoveryState | null = null;

const reducer: Reducer<IAccountRecoveryState | null> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AccountRecovery.ACCOUNT_RECOVERY_INIT: {
      return { authId: action.payload.authId, hasDob: action.payload.hasDob, hasPin: action.payload.hasPin };
    }
    case ActionTypes.AccountRecovery.CREATE_ACCOUNT_RECOVERY_SUCCESS: {
      return { ...state, ...action.payload.response };
    }
    case ActionTypes.AccountRecovery.EMAIL_VERIFY_SUCCESS: {
      return { ...state, ...action.payload.response };
    }
    case ActionTypes.AccountRecovery.ADD_IDENTITY_SUCCESS: {
      return { ...state, mobileIdentity: action.payload.response };
    }
    case ActionTypes.AccountRecovery.ACCOUNT_RECOVERY_CLEAR: {
      return null;
    }
    default: {
      return state;
    }
  }
};

export { reducer as accountRecoveryReducer };
